import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=567dd632&scoped=true&"
import script from "./SummaryPage.vue?vue&type=script&lang=js&"
export * from "./SummaryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dd632",
  null
  
)

export default component.exports